import React from "react";
import { empty, extractDataFromArray, logoutCookies, signInCallback, validPassword } from "../utils/utils&validatation";
import CustomInput from "../components/CustomInput";
import Button from "../components/Button";
import PageHeader from "../components/Header";
import CustomIcon from "../components/CustomIcon";
import { isUserLoggedInApi, oAuthSigninApi, signInApi, signOutApi } from "../apis/authService";
import "../App.css";
import MFA from "../utils/mfa";
import { PublicClientApplication } from "@azure/msal-browser";
import { useNavigate } from "react-router-dom";
import useReloadOnBack from "./hooks/useReloadOnBack";

const Login = () => {
    const navigate = useNavigate();

    const [loginCred, setLoginCred] = React.useState({
        email: "",
        password: ""
    });

    const [loginError, setLoginError] = React.useState({
        type: "",
        errorMsg: ""
    });

    const handleLoginErrorEmpty = () => {
        setLoginError({ type: "", errorMsg: "" });
    };

    const [disabled, setDisabled] = React.useState(true);
    const page = "";

    const handleChange = (e, type) => {
        setLoginError({ type: "", errorMsg: "" });
        setLoginCred(prev => ({ ...prev, [type]: e.target.value }));
    };

    const handleSignIn = async (e, captchaToken = null) => {
        if (e) {
            e.preventDefault();
        }

        setLoginError({ type: "", errorMsg: "" });

        let isValid = true;

        // Password validation
        // const passwordCheck = validPassword(loginCred.password);
        // if (passwordCheck.isError) {
        //     setLoginError({ type: "password", errorMsg: passwordCheck.errorMsg });
        //     isValid = false;
        // }

        if (isValid) {
            const requestData = {
                cmd: "signIn",
                email: loginCred.email,
                pass: loginCred.password,
                remember_me: "on",
                login_type: "login",
                getAuthToken: 1,
                _t: captchaToken ?? "",
            };

            try {
                const response = await signInApi(requestData);

                if (!empty(response.data)) {
                    if (extractDataFromArray(response, ["data", "captcha"], "") === "required") {
                        const existingCaptcha = document.getElementById("captcha");
                        if (existingCaptcha) existingCaptcha.remove();

                        const captchaDiv = document.createElement("div");
                        captchaDiv.classList.add("h-captcha");
                        captchaDiv.id = "captcha";

                        document.querySelector("form").insertAdjacentElement("beforeend", captchaDiv);

                        // Render hCaptcha once the div is added
                        window.hcaptcha.render("captcha", {
                            sitekey: "5a748872-cb02-48d2-8400-73e887629480",
                            callback: captchaLoginCallback,
                            "error-callback": onError,
                        });

                        document.querySelector(".signin_form button[type=submit]").disabled = true;
                        return
                    }

                    if (typeof window.user_info !== "undefined") {
                        Object.keys(response.data).forEach(key => {
                            window.user_info[key] = response.data[key]
                        })
                    }

                    let loginErrorCode = extractDataFromArray(response.data, ["login_error_code"], "");
                    if (loginErrorCode === "MFA_SETUP_REQUIRED") {
                        console.log("MFA_SETUP_REQUIRED");
                        MFA.getActivationLink(loginCred.email, loginCred.pass, extractDataFromArray(response, ["data", "auth_token_str"], ""));
                    } else if (loginErrorCode === "TOTP_MISSING") {
                        MFA.showVerify2FAPopup(loginCred.email, loginCred.password);
                    } else if (loginErrorCode === "TOTP_INVALID") {
                        console.log("TOTP_INVALID");
                    } else {
                        signInCallback(requestData, response);
                        handleLoginErrorEmpty();
                    }
                } else {
                    if (extractDataFromArray(response, ["errorCode"], 1)) {
                        setLoginError({ type: "password", errorMsg: response.errorMsg });
                    }
                }
            } catch (err) {
                console.log("oAuthSigninApi error =>", err);
            }
        };
    }

    function captchaLoginCallback(response) {
        // setCaptchaSolved(true);

        const existingInput = document.querySelector(".signin_form input[name=_t]");
        if (!existingInput) {
            const inputElement = document.createElement("input");
            inputElement.setAttribute("name", "_t");
            inputElement.setAttribute("type", "hidden");
            document.querySelector(".signin_form").appendChild(inputElement);
        }

        document.querySelector(".signin_form input[name=_t]").value = response;

        const submitButton = document.querySelector(".signin_form button[type=submit]");
        if (submitButton) {
            submitButton.disabled = false;
        }

        handleSignIn(null, response);
    }

    function onError() {
        const submitButton = document.querySelector(".signin_form button[type=submit]");
        if (submitButton) {
            submitButton.disabled = true;
        }
    }

    React.useEffect(() => {
        if (loginCred.email !== "" && loginCred.password !== "") {
            setDisabled(false);
        } else {
            setDisabled(true);
        }
    }, [loginCred]);

    const handleCredentialResponse = async (response, typeOfSso = null) => {
        // console.log("response", response);
        const accountId = extractDataFromArray(window.location.pathname.split("/"), [1], "");

        try {
            const result = await oAuthSigninApi({
                cmd: typeOfSso === "microsoft" ? "verifyMSToken" : "verifyGoogleToken",
                token: typeOfSso === "microsoft" ? response.accessToken : response.credential,
                sub_account: page === "subAccountSso" ? 1 : 0,
                account_id: accountId,
            });

            if (!empty(result.data)) {
                signInCallback({ cmd: "signin" }, result);
                handleLoginErrorEmpty();
            } else {
                setLoginError({ type: "password", errorMsg: extractDataFromArray(result, ["errorMsg"], "") });
            }

        } catch (err) {
            console.log("oAuthSigninApi error =>", err);
        }
    };

    // Google OAuth
    React.useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://accounts.google.com/gsi/client";
        script.async = true;
        script.defer = true;

        script.onload = () => {
            window.google.accounts.id.initialize({
                client_id: "151629945985-qojmtvskoi87eq08o5q7q618qmt12nlj.apps.googleusercontent.com",
                callback: handleCredentialResponse,
            });

            const googleSSOElement = document.getElementById("google_sso");
            window.google.accounts.id.renderButton(googleSSOElement, {
                theme: "outline",
                type: "icon",
                shape: "circle",
            });

            window.google.accounts.id.prompt();
        };

        document.body.appendChild(script);
    }, []);

    // Microsoft OAuth
    const handleMicrosoftSignin = async () => {
        const msalConfig = {
            auth: {
                clientId: "6cb6ae3c-54e7-4f2a-88f0-02bcc4b1ffe1",
                authority: "https://login.microsoftonline.com/common",
                redirectUri: window.location.origin,
            },
            cache: {
                cacheLocation: "sessionStorage",
                storeAuthStateInCookie: false,
            },
        };

        const msalInstance = new PublicClientApplication(msalConfig);

        try {
            await msalInstance.initialize();

            const response = await msalInstance.loginPopup({
                scopes: ["openid", "profile", "User.Read"],
            });

            await handleCredentialResponse(response, "microsoft");
        } catch (err) {
            console.log("Error in Microsoft OAuth login:", err);
        }
    };

    const [isLoggedIn, setIsLoggedIn] = React.useState("checking");

    React.useEffect(() => {
        async function fetchUserStatus() {
            try {
                const res = await isUserLoggedInApi({ cmd: "isUserLoggedIn " });
                if (extractDataFromArray(res, ["errorCode"]) === 0) {
                    signInCallback(res.data);
                    setIsLoggedIn("logged-in");
                } else {
                    setIsLoggedIn("logged-out");
                }
            } catch (err) {
                console.log("Error in isUserLoggedInApi (login):", err);
                setIsLoggedIn("logged-out");
            }
        };
        fetchUserStatus();
    }, []);

    const handleLogout = React.useCallback(async () => {
        try {
            const res = await signOutApi({ cmd: "signOut" });
            if (extractDataFromArray(res, ["errorCode"], 1) == 0) {
                logoutCookies();
                navigate("/event-scanner/login");
            }
        } catch (err) {
            console.error("Error inside signOutApi =>", err)
        }
    }, [navigate]);

    React.useEffect(() => {
        if (isLoggedIn === "logged-out") handleLogout();
    }, [isLoggedIn, handleLogout]);

    useReloadOnBack();

    return (
        <div className="h-auto w-85 bc-white">
            <PageHeader />

            <form className="w-full bc-white signin_form mb-8" onSubmit={handleSignIn}>
                <CustomInput
                    className="w-full bc-white mb-6 font-sm"
                    id="email"
                    // type="email"
                    value={loginCred.email}
                    placeholder="Official Email / Login ID*"
                    onChange={(e) => handleChange(e, "email")}
                    required
                    isError={loginError.type === "email"}
                    errorMsg={loginError.type === "email" ? loginError.errorMsg : ""}
                    style={{ padding: "0.620rem .75rem", height: "40px", minHeight: "40px" }}
                />

                <CustomInput
                    className="w-full bc-white mb-10 font-sm"
                    id="password"
                    type="password"
                    value={loginCred.password}
                    placeholder="Password*"
                    onChange={(e) => handleChange(e, "password")}
                    required
                    isError={loginError.type === "password"}
                    errorMsg={loginError.type === "password" ? loginError.errorMsg : ""}
                    style={{
                        padding: "0.620rem .75rem", height: "40px", minHeight: "40px"
                    }}
                />

                <Button
                    className="login w-full font-sm"
                    buttonText="Login"
                    disabled={disabled}
                />
            </form>


            {
                window.location.origin.endsWith("qrcodechimp.com") &&
                <div className="flex g-6 mt-8 justify-center bc-white">
                    <CustomIcon
                        id="google_sso"
                    />

                    <CustomIcon
                        onClick={handleMicrosoftSignin}
                        className="login-icon"
                        src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
                        alt="microsoft-logo"
                        style={{ width: "38px", height: "38px" }}
                    />
                </div>
            }
        </div>
    );
};

export default Login;